import Manifesto from "../components/Manifesto";
import Marquee from "../components/Marquee";

export default function PropositoPage() {
  return (
    <div data-testid="page-proposito" className="pt-24 sm:pt-32">
      <Manifesto />
      <Marquee />
    </div>
  );
}
